import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="wake-lock"
export default class extends Controller {
  async connect() {
    this.wakeLock = null;
    this.active = true;
    await this.request();
  }

  disconnect() {
    this.active = false;
    this.release();
  }

  async request() {
    if (!this.active || !("wakeLock" in navigator) || !this.isMobile()) return;
    try {
      const lock = await navigator.wakeLock.request("screen");
      if (this.active) {
        this.wakeLock = lock;
      } else {
        await lock.release();
      }
    } catch (e) {
      // denied / low battery / not foreground — degrade silently
    }
  }

  async release() {
    try {
      await this.wakeLock?.release();
    } finally {
      this.wakeLock = null;
    }
  }

  reacquire() {
    if (document.visibilityState === "visible") this.request();
  }

  isMobile() {
    if (navigator.userAgentData) return navigator.userAgentData.mobile;
    return window.matchMedia("(pointer: coarse)").matches;
  }
}
